var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"titleColor--text ml-0 pl-0 mb-0",attrs:{"disabled":_vm.disabled,"flat":""},on:{"click":function($event){return _vm.$emit('volver')}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("chevron_left")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.texto))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e1ffa94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/OBtnVolver.vue
// module id = null
// module chunks = 